module.exports = {"failed":"Het inloggen is mislukt","success":"Het inloggen is geslaagd"}


//////////////////
// WEBPACK FOOTER
// ./src/locale/nl/auth.json
// module id = bfkd
// module chunks = 15